export default __webpack_public_path__ + "static/logo_black-e1c7f2a55ad0e1c9828460759659e1b8.png";